import axios from "axios";
axios.defaults.withCredentials = true;
import errorHandler from "@/scripts/errorHandler";
import { getApiBaseUrl } from "@/utils/RuntimeConfig";
import qs from "qs";

// 配置API接口地址（通过运行时 config.js 注入，无 config.js 时默认同源）
let baseApi = getApiBaseUrl() + "/";
export default class Axios2 {

  static getTokenFromUrl() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get("token");

      if (tokenFromUrl) {
        // JWT格式验证
        const isValidFormat = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(tokenFromUrl);

        if (!isValidFormat) {
          console.error("❌ URL参数token格式非法");
          return null;
        }

        sessionStorage.setItem("token", tokenFromUrl);

        // ponytail: 只摘掉 token，其余 query（如报告免登入口的 reportId）保留，否则刷新后参数就没了
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);

        console.log("✅ Token已从URL参数自动注入sessionStorage");
        return tokenFromUrl;
      }
    } catch (error) {
      console.error("获取URL参数token失败:", error);
    }
    return null;
  }

  static getToken() {
    const tokenFromUrl = Axios2.getTokenFromUrl();
    if (tokenFromUrl) {
      return tokenFromUrl;
    }
    // ponytail: 免登入口的 token 落在 sessionStorage（本标签页会话级），需优先于 localStorage 的登录态
    const tokenFromSession = sessionStorage.getItem("token");
    if (tokenFromSession) {
      return tokenFromSession;
    }
    const tokenFromStorage = localStorage.getItem("token");
    if (tokenFromStorage) {
      return tokenFromStorage;
    }
    console.warn("⚠️ 未找到可用的token，请重新登录");
    return null;
  }

  static clearToken() {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    delete axios.defaults.headers.common["authorization"];
  }

  static ajax(options) {
    return new Promise((resolve, reject) => {
      const token = Axios2.getToken();

      if (!token) {
        if (window.location.pathname !== '/login') {
          window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href);
        }
        reject({
          success: false,
          message: "认证失败：未找到有效的token",
          code: 401
        });
        return;
      }

      axios.defaults.headers.common["authorization"] = token;

      axios({
        url: options.url,
        method: options.method || 'POST',
        baseURL: baseApi,
        timeout: 80000,
        data: options.data || null,
        params: options.params || null,
        // ponytail: 剔除 js undefined 与字符串 "undefined"，避免 GET 整数参数绑定 typeMismatch（qs 会跳过 undefined 但保留 "undefined" 字符串）
        paramsSerializer: params => {
          const clean = {};
          Object.keys(params).forEach(key => {
            const v = params[key];
            if (v !== undefined && v !== 'undefined') {
              clean[key] = v;
            }
          });
          return qs.stringify(clean, { arrayFormat: 'repeat' });
        },
        headers: options.headers || {}
      })
        .then((response) => {
          if (errorHandler.handleRequestRes(response)) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          // ✅ 修正后的语法（传统&&写法）
          if (error.code === 401) {
            Axios2.clearToken();
            window.location.href = '/login?error=expired';
          }
          reject(error);
        });
    });
  }
}
